import { AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * URL Validator
 * Validates that a URL starts with http://, https://, or www. and has proper format
 * 
 * Usage:
 * this.form = this.fb.group({
 *   webViewUrl: ['', [Validators.required, urlValidator]]
 * });
 * 
 * Accepted formats:
 * - https://example.com
 * - http://example.com
 * - www.example.com
 */
export function urlValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null; // Let required validator handle empty values
  }

  // URL pattern that accepts http://, https://, or www.
  const urlPattern = /^(http:\/\/|https:\/\/)[a-zA-Z0-9\-\.]+\.[a-zA-Z]{2,}(\/\S*)?$/;
  
  if (!urlPattern.test(control.value)) {
    return { invalidUrl: true };
  }
  
  return null;
}
